// ¿Arranca el video de fondo del login? (S5-4 · P1-17)
//
// Es decoración: 4 MB al 13 % de opacidad. Con `autoPlay` y sin `preload`
// competía con el formulario por la red justo durante el LCP (p75 4,9 s).
// Ahora solo arranca después del `load`, y nunca si la persona pidió menos
// movimiento o su conexión es lenta / en ahorro de datos.

export interface HeroVideoEnv {
  /** `matchMedia("(prefers-reduced-motion: reduce)").matches` */
  reducedMotion: boolean
  /** `navigator.connection.saveData` (solo Chromium) */
  saveData?: boolean
  /** `navigator.connection.effectiveType` (solo Chromium) */
  effectiveType?: string
}

const SLOW_CONNECTIONS = new Set(["slow-2g", "2g", "3g"])

export function shouldAutoplayHeroVideo(env: HeroVideoEnv): boolean {
  if (env.reducedMotion) return false
  if (env.saveData) return false
  if (env.effectiveType && SLOW_CONNECTIONS.has(env.effectiveType)) return false
  return true
}
